<script setup>
import EntryName from '@/components/EntryName.vue'
import { computed } from 'vue'

const props = defineProps({
  round: {
    type: Object,
    required: true
  }
})

const firstGame = computed(() => props.round.games && props.round.games.length > 0 ? props.round.games[0] : null)
const firstGameWinners = computed(() => {
  if (!firstGame.value || !firstGame.value.game_entries) return null
  const entries = [...firstGame.value.game_entries].sort((a, b) => a.position - b.position)
  return [
    entries[0],
    entries[1],
    entries[2]
  ]
})
</script>


<template>
  <div v-if="firstGameWinners[0]" class="d-flex flex-row justify-center align-end mb-6">
    <div class="podium-second d-flex flex-column align-center justify-end mx-2">
      <template v-if="firstGameWinners[1]">
        <div class="podium-label text-caption mb-1">2°</div>
        <div class="podium-box bg-grey-darken-3 px-3 py-2 rounded-t d-flex align-center">
          <div class="text-center">
          <EntryName :entryId="firstGameWinners[1].entry_id" />
          </div>
        </div>
      </template>        
    </div>
    
    <div class="podium-first d-flex flex-column align-center justify-end mx-2">
      <v-icon color="amber" size="32" class="mb-1">mdi-crown-outline</v-icon>
      <div class="podium-label text-caption mb-1">1°</div>
      <div class="podium-box bg-grey-lighten-1 px-4 py-3 rounded-t text-h6 font-weight-bold">
        <div class="text-center">
          <EntryName :entryId="firstGameWinners[0].entry_id" />
        </div>
      </div>
    </div>

    <div class="podium-third d-flex flex-column align-center justify-end mx-2">
      <template v-if="firstGameWinners[2]">
        <div class="podium-label text-caption mb-1">3°</div>
        <div class="podium-box bg-grey-darken-3 px-3 py-2 rounded-t d-flex align-center">
          <div class="text-center">
            <EntryName :entryId="firstGameWinners[2].entry_id" />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
